const { default: createApi } = require("./api");

const api = createApi({
  baseUrl: `reports`,
  headers: {
    'Content-Type': 'application/json'
  },
})

export default class BIService {

  async getSource({ dashboardId }) {
    return api.post('bi', {
      dashboard_id: dashboardId,
    });
  }
  
}